import React from 'react';
import PropTypes from 'prop-types';
import Container from '../PageBuilder/lib/Container';

const SectionTitleWidget = ({ title, variant, align, containerSettings }) => (
  <Container className="section-title-wrapper" settings={containerSettings}>
    <div className="container">
      <h3 className={`section-title ${variant === 'regular' ? '' : 'all-caps'} ${align === 'center' ? 'text-center' : ''}`}>{title}</h3>
    </div>
  </Container>
);

SectionTitleWidget.title = 'Section Title';
SectionTitleWidget.preview = 'section-title.png';
SectionTitleWidget.category = 'Content';


SectionTitleWidget.propTypes = {
  title: PropTypes.string.isRequired,
  variant: PropTypes.string.isRequired,
  align: PropTypes.string.isRequired,
  containerSettings: PropTypes.object.isRequired,
};

SectionTitleWidget.defaults = {
  title: 'Section Title',
  variant: 'regular',
  align: 'left',
  containerSettings: {},
};

SectionTitleWidget.adminFields = {
  title: { type: 'text' },
  variant: { type: 'select', options: [['regular', 'Regular'], ['allCaps', 'All Caps']] },
  align: { type: 'select', options: [['left', 'Left'], ['center', 'Center']] },
};

export default SectionTitleWidget;
